module.exports = __webpack_public_path__ + "img/271.af63f0ae.png";